import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const FabricRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.fabric_master_create === true ||
    permissions.fabric_master_edit === true ||
    permissions.fabric_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default FabricRouteMiddleware;
